import type { Scope } from '../types/scopeState';

/**
 * Returns the active status of a Scope based on its deleted flag
 * @param scope
 * @returns
 */
export const isActiveScope = (scope: Scope) => !scope.__scopeMeta.deleted;
